import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function BNYSSyllabus() {
  const [menuOpen, setMenuOpen] = useState(false);

  const syllabusFiles = [
    {
      id: 1,
      title: 'NATIONAL INSTITUTE OF NATUROPATHY, PUNE',
      fileName: 'BNYS New Syllabus_ Final_NIN.pdf'
    },
    {
      id: 2,
      title: 'RAJIV GANDHI UNIVERSITY OF HEALTH SCIENCES, KARNATAKA',
      fileName: 'Notification Curriculum of BNYS RGUHS BANGALORE.pdf'
    },
    {
      id: 3,
      title: 'THE TAMIL NADU Dr. M.G.R. MEDICAL UNIVERSITY, CHENNAI',
      fileName: 'THE TAMIL NADU DR MGR MEDICAL UNIVERSITY.pdf'
    },
    {
      id: 4,
      title: 'SWAMI VIVEKANANDA YOGA ANUSANDHANA SAMSTHANA, BANGALORE',
      fileName: null
    },
    {
      id: 5,
      title: 'SWAMI VIVEKANANDA SUBHARTI UNIVERSITY, MEERUT',
      fileName: 'SUBHARTI UNIVERSITY, MEERUT.pdf'
    },
    {
      id: 6,
      title: 'DR. SARVEPALLI RADHAKRISHNAN RAJASTHAN AYURVED UNIVERSITY, JODHPUR',
      fileName: 'Dr. Sarvepalli Radhakrishnan Rajasthan Ayurved University, Jodhpur..pdf'
    },
    {
      id: 7,
      title: 'IGTAMSU, ZIRO (ARUNACHAL PRADESH)',
      fileName: 'BNYS SYLLABUS 2024-INDIRA GANDHI TECHNOLOGICAL AND MEDICAL SCIENCES UNIVERSITY.pdf'
    },
    {
      id: 8,
      title: 'SHREE GURU GOBIND SINGH TRICENTENARY UNIVERSITY, GURUGRAM',
      fileName: 'SYLLABUS-Bachelor-of-Naturopathy-Yogic-Sciences-2024 SGT UNIVERSITY, BUDHERA, GURUGRAM RURAL, HARYANA.pdf'
    },
    {
      id: 9,
      title: 'YENEPOYA ((DEEMED TO BE UNIVERSITY)), MANGALORE',
      fileName: 'YNYSCH BNYS Syllabus consolidated.pdf'
    },
    {
      id: 10,
      title: 'JAYOTI VIDYAPEETH WOMEN\'S UNIVERSITY, JAIPUR',
      fileName: 'BYNS SYLLABUS-JAYOTI VIDYAPEETH WOMEN’S UNIVERSITY, JAIPUR.pdf'
    },
    {
      id: 11,
      title: 'SANT HIRDARAM MEDICAL COLLEGE OF NATUROPATHY AND YOGIC SCIENCES, BAIRAGARH, BHOPAL',
      fileName: 'SHMC of N & Y.S.- Ordinance & Syllabus Page No.From 1 to 13 - Copy.pdf'
    },
    {
      id: 12,
      title: 'GOA UNIVERSITY',
      fileName: 'goa university.pdf'
    },
    {
      id: 13,
      title: 'RAJASTHAN AYURVEDA UNIVERSITY, JODHPUR',
      fileName: 'Rajasthan Ayurveda University.pdf'
    }
  ];

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>

          <div className="topbar-marquee-group">
            <Notification />
            <Notification
              variant="danger"
              messages={[
                'State registration is mandatory as part of the NRB-HPR integrated registration process. Kindly download the HPR Certificate and I-card from HPR Portal through this link https://nhpr.abdm.gov.in/nhpr/v4/login'
              ]}
            />
          </div>
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* BNYS Syllabus Content */}
      <div style={{
        minHeight: '70vh',
        padding: '60px 20px',
        background: '#ffffff'
      }}>
        <div style={{
          maxWidth: '1100px',
          margin: '0 auto'
        }}>
          <h1 style={{
            fontSize: '2.2rem',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '12px',
            color: '#2c3e50'
          }}>
            Bachelor of Naturopathy and Yogic Sciences (BNYS) Syllabus
          </h1>

          <p style={{
            textAlign: 'center',
            color: '#4b5563',
            fontSize: '1.05rem',
            marginBottom: '34px'
          }}>
            Click on the files below to view or download the syllabus:
          </p>

          <div style={{
            background: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '16px'
          }}>
            {syllabusFiles.map((item) => (
              item.fileName ? (
                <a
                  key={item.id}
                  href={`/pdf/${encodeURIComponent(item.fileName)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '16px',
                    alignItems: 'center',
                    textDecoration: 'none',
                    background: '#ffffff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '10px',
                    padding: '14px 16px',
                    marginBottom: '10px'
                  }}
                >
                  <span style={{ color: '#1f2937', lineHeight: '1.5' }}>{item.title}</span>
                  <span style={{
                    color: '#0b4f7d',
                    fontWeight: '600',
                    whiteSpace: 'nowrap'
                  }}>
                    View / Download PDF
                  </span>
                </a>
              ) : (
                <div
                  key={item.id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '16px',
                    alignItems: 'center',
                    background: '#ffffff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '10px',
                    padding: '14px 16px',
                    marginBottom: '10px'
                  }}
                >
                  <span style={{ color: '#1f2937', lineHeight: '1.5' }}>{item.title}</span>
                  <span style={{
                    color: '#6b7280',
                    fontWeight: '600',
                    whiteSpace: 'nowrap'
                  }}>
                    PDF not uploaded yet
                  </span>
                </div>
              )
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default BNYSSyllabus;

